/* Ivevar: free ring engraving. Runs the engraving block and adds its text and font to the ring options popup's add to cart. */
(function () {
  if (window.__ivvEng) return;
  window.__ivvEng = true;

  var MAX = 20;
  var SCALE = { Minimal: 1, Script: 1.2, Cursive: 1.3 };
  var TRIGGER = 'button[name="add"], button.add-to-cart, .shopify-payment-button__button, .shopify-payment-button, shopify-accelerated-checkout, .prod__dynamic_checkout';
  var activePid = null;
  var fontsLoaded = false;

  function q(root, sel) { return root.querySelector(sel); }
  function blockOf(el) { return el.closest ? el.closest('[data-ivv-eng]') : null; }
  function activeBlock(pid) {
    var list = document.querySelectorAll('[data-ivv-eng="' + pid + '"]');
    for (var i = 0; i < list.length; i++) if (q(list[i], '[data-ivv-eng-on]').checked) return list[i];
    return null;
  }
  function value(pid) {
    var b = pid && activeBlock(pid);
    if (!b) return null;
    var text = q(b, '[data-ivv-eng-text]').value.trim();
    return text ? { text: text, font: b.getAttribute('data-font') } : null;
  }

  // The two engraving fonts load only when a customer turns engraving on
  function loadFonts() {
    if (fontsLoaded) return;
    fontsLoaded = true;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@1,500&family=Great+Vibes&display=swap';
    document.head.appendChild(l);
  }

  function setMetal(b) {
    var picker = document.querySelector('[data-variant-picker][data-product-id="' + b.getAttribute('data-ivv-eng') + '"]');
    var fields = picker ? picker.querySelectorAll('[data-option-name]') : [];
    var val = '';
    for (var i = 0; i < fields.length; i++) {
      if (!/metal|gold/i.test(fields[i].getAttribute('data-option-name'))) continue;
      var on = q(fields[i], 'input:checked, select');
      val = (on && on.value) || fields[i].getAttribute('data-selected-value') || '';
      break;
    }
    b.setAttribute('data-metal', /rose/i.test(val) ? 'rose' : /yellow/i.test(val) ? 'yellow' : 'silver');
  }

  function render(b) {
    var input = q(b, '[data-ivv-eng-text]');
    var clean = input.value.replace(/[\p{Extended_Pictographic}‍️]/gu, '');
    if (clean !== input.value) input.value = clean;
    var text = clean.trim();
    q(b, '[data-ivv-eng-count]').textContent = clean.length + '/' + MAX;
    var path = q(b, '[data-ivv-eng-preview]');
    var svgText = path.parentNode;
    path.textContent = text || 'Your text';
    svgText.classList.toggle('is-empty', !text);
    var size = text.length > 8 ? 32 - (text.length - 8) * 1.1 : 32;
    svgText.setAttribute('font-size', (size * (SCALE[b.getAttribute('data-font')] || 1)).toFixed(1));
    if (text) {
      b.classList.remove('is-missing');
      q(b, '[data-ivv-eng-err]').hidden = true;
    }
  }

  function toggle(b, on) {
    q(b, '[data-ivv-eng-body]').hidden = !on;
    q(b, '[data-ivv-eng-text]').disabled = !on;
    q(b, '[data-ivv-eng-font]').disabled = !on;
    if (on) { loadFonts(); setMetal(b); render(b); }
    else { b.classList.remove('is-missing'); q(b, '[data-ivv-eng-err]').hidden = true; }
  }

  function pick(b, font) {
    b.setAttribute('data-font', font);
    q(b, '[data-ivv-eng-font]').value = font;
    var btns = b.querySelectorAll('[data-ivv-eng-pick]');
    for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-checked', String(btns[i].getAttribute('data-ivv-eng-pick') === font));
    render(b);
  }

  // Engraving switched on with no text: stop and show the field
  function isMissing(pid) {
    var b = activeBlock(pid);
    if (!b || value(pid)) return false;
    var input = q(b, '[data-ivv-eng-text]');
    b.classList.add('is-missing');
    q(b, '[data-ivv-eng-err]').hidden = false;
    b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 450);
    return true;
  }
  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-ivv-eng-on]')) { toggle(blockOf(t), t.checked); return; }
    setTimeout(function () {
      var list = document.querySelectorAll('[data-ivv-eng]');
      for (var i = 0; i < list.length; i++) setMetal(list[i]);
    }, 80);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ivv-eng-text]')) render(blockOf(e.target));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ivv-eng-text]')) e.preventDefault();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ivv-eng-pick]');
    if (btn) pick(blockOf(btn), btn.getAttribute('data-ivv-eng-pick'));
  });

  // These run before ivevar-offers.js opens the ring options popup
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(TRIGGER);
    if (!btn || btn.closest('.ivv-modal')) return;
    var holder = btn.closest('form[data-product-id]') || btn.closest('[data-product-id]');
    var pid = holder && holder.getAttribute('data-product-id');
    if (!pid) return;
    activePid = pid;
    if (isMissing(pid)) stop(e);
  }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.getAttribute || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var pid = form.getAttribute('data-product-id');
    if (!pid) return;
    activePid = pid;
    if (isMissing(pid)) stop(e);
  }, true);

  // Show the engraving in the popup so the customer can check it
  new MutationObserver(function () {
    var body = document.querySelector('.ivv-modal .ivv-body');
    var v = value(activePid);
    if (!body || !v || body.querySelector('.ivv-eng-sum')) return;
    var row = document.createElement('div');
    row.className = 'ivv-eng-sum';
    var em = document.createElement('em');
    em.textContent = v.text + ' (' + v.font + ')';
    row.appendChild(document.createTextNode('Engraving: '));
    row.appendChild(em);
    body.appendChild(row);
  }).observe(document.body, { childList: true });

  // The popup adds the ring by itself, so its request gets the engraving here
  var realFetch = window.fetch;
  window.fetch = function (url, opts) {
    try {
      var v = value(activePid);
      if (v && typeof url === 'string' && url.indexOf('/cart/add.js') > -1 && opts && typeof opts.body === 'string') {
        var body = JSON.parse(opts.body);
        var item = body.items && body.items[0];
        if (item && item.properties && item.properties['Ring Size']) {
          item.properties['Engraving'] = v.text;
          item.properties['Engraving Font'] = v.font;
          opts = Object.assign({}, opts, { body: JSON.stringify(body) });
        }
      }
    } catch (e) {}
    return realFetch.call(window, url, opts);
  };
})();
